/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconPisces: {
  name: 'pisces';
  data: string;
} = {
  name: 'pisces',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M335.907 264.467c8.249-95.019 47.875-177.689 105.103-230.137h104.884c-57.228 52.448-90.193 135.117-96.917 230.137h84.487v94.968h-82.537c10.02 87.478 43.158 162.877 97.406 211.367H443.448c-54.254-48.49-93.121-123.895-105.183-211.367h-69.198c-12.062 87.478-50.929 162.877-105.183 211.367H59.005c54.248-48.49 87.375-123.895 97.406-211.367H67.018v-94.968h91.344c-6.736-95.019-39.69-177.689-96.917-230.137h104.89c57.216 52.448 96.848 135.117 105.091 230.137h64.481z"/></svg>`,
};
